const translationKeys = {
  become_customer_information_intro: 'become_customer_information_intro',
  become_customer_information_title: 'become_customer_information_title',
  become_customer_start_application_button:
    'become_customer_start_application_button',
  become_customer_start_application_minutes_title:
    'become_customer_start_application_minutes_title',
  become_customer_start_application_minutes_message:
    'become_customer_start_application_minutes_message',
  become_customer_start_application_personal_info_title:
    'become_customer_start_application_personal_info_title',
  become_customer_start_application_personal_info_message:
    'become_customer_start_application_personal_info_message',
  become_customer_start_application_usage_title:
    'become_customer_start_application_usage_title',
  become_customer_start_application_usage_message:
    'become_customer_start_application_usage_message',
  become_customer_personal_info_information:
    'become_customer_personal_info_information',
  become_customer_personal_info_date_of_birth:
    'become_customer_personal_info_date_of_birth',
  become_customer_personal_info_first_name:
    'become_customer_personal_info_first_name',
  become_customer_personal_info_last_name:
    'become_customer_personal_info_last_name',
  become_customer_personal_info_email: 'become_customer_personal_info_email',
  become_customer_personal_info_confirm_email:
    'become_customer_personal_info_confirm_email',
  become_customer_personal_info_residential_address_in_norway:
    'become_customer_personal_info_residential_address_in_norway',
  become_customer_personal_info_street_address_1:
    'become_customer_personal_info_street_address_1',
  become_customer_personal_info_street_address_2:
    'become_customer_personal_info_street_address_2',
  become_customer_personal_info_postal_code:
    'become_customer_personal_info_postal_code',
  become_customer_personal_info_post_office:
    'become_customer_personal_info_post_office',
  become_customer_personal_info_postal_info:
    'become_customer_personal_info_postal_info',
  become_customer_personal_info_postal_info_country:
    'become_customer_personal_info_postal_info_country',
  become_customer_motherland: 'become_customer_motherland',
  become_customer_motherland_country: 'become_customer_motherland_country',
  become_customer_background_status: 'become_customer_background_status',
  become_customer_background_parent_dob:
    'become_customer_background_parent_dob',
  become_customer_background_parent_dob_1:
    'become_customer_background_parent_dob_1',
  become_customer_background_parent_dob_2:
    'become_customer_background_parent_dob_2',
  become_customer_purpose_title: 'become_customer_purpose_title',
  become_customer_background_title: 'become_customer_background_title',
  become_customer_tax_title: 'become_customer_tax_title',
  become_customer_citizenship_title: 'become_customer_citizenship_title',
  become_customer_motherland_title: 'become_customer_motherland_title',
  become_customer_personal_info_title: 'become_customer_personal_info_title',
  become_customer_purpose_usage: 'become_customer_purpose_usage',
  become_customer_purpose_usage_regular_banking:
    'become_customer_purpose_usage_regular_banking',
  become_customer_purpose_usage_investments:
    'become_customer_purpose_usage_investments',
  become_customer_purpose_usage_other: 'become_customer_purpose_usage_other',
  become_customer_income_origin: 'become_customer_income_origin',
  become_customer_foreign_use_title: 'become_customer_foreign_use_title',
  become_customer_foreign_use_card: 'become_customer_foreign_use_card',
  become_customer_pep_title: 'become_customer_pep_title',
  become_customer_pep_are_you: 'become_customer_pep_are_you',
  become_customer_disponents_title: 'become_customer_disponents_title',
  become_customer_citizenship_country: 'become_customer_citizenship_country',
  become_customer_citizenship_country_select:
    'become_customer_citizenship_country_select',
  become_customer_citizenship_other_country:
    'become_customer_citizenship_other_country',
  become_customer_tax_other_countries: 'become_customer_tax_other_countries',
  become_customer_background_status_select:
    'become_customer_background_status_select',
  become_customer_purpose_usage_select: 'become_customer_purpose_usage_select',
  become_customer_income_origin_select: 'become_customer_income_origin_select',
  become_customer_income_title: 'become_customer_income_title',
  become_customer_personal_info_phone_number:
    'become_customer_personal_info_phone_number',
  become_customer_background_status_minor_select:
    'become_customer_background_status_minor_select',
  become_customer_background_parent_dob_select:
    'become_customer_background_parent_dob_select',
  become_customer_foreign_use_card_select:
    'become_customer_foreign_use_card_select',
  become_customer_disponents_access: 'become_customer_disponents_access',
  become_customer_disponents_access_select:
    'become_customer_disponents_access_select',
  become_customer_disponents_pep: 'become_customer_disponents_pep',
  become_customer_disponents_pep_name: 'become_customer_disponents_pep_name',
  become_customer_disponents_pep_first_name:
    'become_customer_disponents_pep_first_name',
  become_customer_disponents_pep_last_name:
    'become_customer_disponents_pep_last_name',
  become_customer_disponents_pep_receive_money:
    'become_customer_disponents_pep_receive_money',
  become_customer_disponents_pep_money_origin:
    'become_customer_disponents_pep_money_origin',
  become_customer_disponents_pep_money_origin_select:
    'become_customer_disponents_pep_money_origin_select',
  become_customer_pep_who_does_it_apply_to:
    'become_customer_pep_who_does_it_apply_to',
  become_customer_pep_who_is: 'become_customer_pep_who_is',
  become_customer_pep_who_is_select: 'become_customer_pep_who_is_select',
  become_customer_pep_personal_info: 'become_customer_pep_personal_info',
  become_customer_pep_sex_title: 'become_customer_pep_sex_title',
  become_customer_pep_sex: 'become_customer_pep_sex',
  become_customer_pep_first_name: 'become_customer_pep_first_name',
  become_customer_pep_last_name: 'become_customer_pep_last_name',
  become_customer_pep_address1: 'become_customer_pep_address1',
  become_customer_pep_address2: 'become_customer_pep_address2',
  become_customer_pep_postal_code: 'become_customer_pep_postal_code',
  become_customer_pep_postal_office: 'become_customer_pep_postal_office',
  become_customer_pep_country: 'become_customer_pep_country',
  become_customer_pep_dob: 'become_customer_pep_dob',
  become_customer_pep_ssn: 'become_customer_pep_ssn',
  become_customer_pep_roles: 'become_customer_pep_roles',
  become_customer_pep_roles_select: 'become_customer_pep_roles_select',
  become_customer_pep_about_role: 'become_customer_pep_about_role',
  become_customer_pep_roles_country: 'become_customer_pep_roles_country',
  become_customer_pep_roles_end_date: 'become_customer_pep_roles_end_date',
  become_customer_pep_money_in_your_account:
    'become_customer_pep_money_in_your_account',
  become_customer_pep_money_origin: 'become_customer_pep_money_origin',
  become_customer_pep_money_select: 'become_customer_pep_money_select',
  become_customer_motherland_renounced_citizenship:
    'become_customer_motherland_renounced_citizenship',
  become_customer_income_other: 'become_customer_income_other',
  become_customer_pep_money_other: 'become_customer_pep_money_other',
  become_customer_disponents_pep_money_origin_other:
    'become_customer_disponents_pep_money_origin_other',
  become_customer_title: 'become_customer_title',
};

Object.freeze(translationKeys);

export default translationKeys;
